import { navigationStore } from "@/store/pinia_modules/navigationStore";
import { vItemStore } from "@/store/pinia_modules/vItemStore";
import { APIClient } from "@/utils/httpClient";

export const generateShare = async (
	campaignId: string,
	userId: string,
	dropPoolId: string | null
): Promise<string | null> => {
	try {
		const endpoint = `/campaigns/${campaignId}/share`;
		const response = await APIClient.post(endpoint, { userId, dropPoolId });
		if (response.success) {
			if (response.data.updateWallet) {
				await vItemStore().getItems();
			}
			return response.data.url;
		}
	} catch (error) {
		console.error(error);
	}
	return null;
};

export const generateShareReward = async (
	campaignId: string,
	userId: string,
	vatID: string | null
): Promise<string | null> => {
	navigationStore().setloading(true);
	try {
		const endpoint = `/campaigns/${campaignId}/vitem/share`;
		const response = await APIClient.post(endpoint, {
			userId: userId,
			vitemID: vatID,
		});
		if (response.success) {
			await vItemStore().getItems();
			navigationStore().setloading(false);
			return response.data.shareId;
		}
	} catch (error) {
		navigationStore().setloading(false);
		console.error(error);
	}
	return null;
};

export const cancelShareReward = async (
	campaignId: string,
	shareId: string
): Promise<string | null> => {
	navigationStore().setloading(true);
	try {
		const endpoint = `/campaigns/${campaignId}/vitem/share/${shareId}/cancel`;
		const response = await APIClient.post(endpoint, {});
		if (response.success) {
			await vItemStore().getItems();
			navigationStore().setloading(false);
			return response.data.shareId;
		}
	} catch (error) {
		navigationStore().setloading(false);
		console.error(error);
	}

	return null;
};
